import React from 'react';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonClass = 'btn btn-primary',
  cancelButtonClass = 'btn btn-secondary'
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: '2rem',
      }}
      onClick={handleOverlayClick}
    >
      <div
        style={{
          backgroundColor: 'var(--bg-card)',
          borderRadius: 'var(--border-radius)',
          border: '1px solid var(--border-color)',
          width: '100%',
          maxWidth: '400px',
          boxShadow: 'var(--shadow-lg)',
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            padding: '1.5rem 1.5rem 1rem 1.5rem',
            borderBottom: '1px solid var(--border-color)',
            backgroundColor: 'var(--bg-secondary)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
            <img
              src="https://taxntips.com/nav-logo.png"
              alt="TaxnTip Logo"
              style={{
                height: '24px',
                width: 'auto',
                marginRight: '0.75rem',
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h3
              style={{
                margin: 0,
                color: 'var(--text-primary)',
                fontSize: '1.25rem',
                fontWeight: '600',
              }}
            >
              {title}
            </h3>
          </div>
        </div>

        {/* Modal Body */}
        <div style={{ padding: '1.5rem' }}>
          <p
            style={{
              margin: 0,
              color: 'var(--text-secondary)',
              lineHeight: '1.5',
              fontSize: '1rem',
            }}
          >
            {message}
          </p>
        </div>

        {/* Modal Footer */}
        <div
          style={{
            padding: '1rem 1.5rem 1.5rem 1.5rem',
            borderTop: '1px solid var(--border-color)',
            backgroundColor: 'var(--bg-secondary)',
            display: 'flex',
            gap: '0.75rem',
            justifyContent: 'flex-end',
          }}
        >
          <button
            onClick={handleCancel}
            className={cancelButtonClass}
            style={{ padding: '0.5rem 1rem' }}
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className={confirmButtonClass}
            style={{ padding: '0.5rem 1rem' }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
